import Table from './Table';
import { Wrapper, Header, HeaderRow, HeaderCell, Body, Row, Cell } from './TableElements';

Table.Wrapper = Wrapper;
Table.Header = Header;
Table.HeaderRow = HeaderRow;
Table.HeaderCell = HeaderCell;
Table.Body = Body;
Table.Row = Row;
Table.Cell = Cell;

export default Table;
